function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { isNull, isEmpty, get } from 'lodash';
import classNames from 'classnames';
import { Combobox } from '@headlessui/react';
import { Icon } from '@unite-us/ui';
import { getPreferredProp } from '@unite-us/ui';
import '../pages/builder/ReferralBuilderForm.scss';
export var SearchableSelectField = function SearchableSelectField(props) {
  var _getPreferredProp;
  var className = props.className,
    clearable = props.clearable,
    hideLabel = props.hideLabel,
    label = props.label,
    labelClassName = props.labelClassName,
    listBoxUpOptionsClassName = props.listBoxUpOptionsClassName,
    onChange = props.onChange,
    options = props.options,
    placeholder = props.placeholder,
    required = props.required,
    truncateOptions = props.truncateOptions,
    onInputChange = props.onInputChange,
    id = props.id,
    _props$style = props.style,
    style = _props$style === void 0 ? {
      container: {},
      label: {},
      input: {},
      hint: {},
      error: {}
    } : _props$style;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var hasError = getPreferredProp(props, 'invalid') && getPreferredProp(props, 'touched');
  var name = getPreferredProp(props, 'name');
  var error = getPreferredProp(props, 'error');
  var reduxOnBlur = getPreferredProp(props, 'onBlur');
  var value = (_getPreferredProp = getPreferredProp(props, 'value')) === null || _getPreferredProp === void 0 ? void 0 : _getPreferredProp.value;
  var selectedOption = options.find(function (option) {
    return option.value === value;
  }) || null;
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    query = _useState4[0],
    setQuery = _useState4[1];
  var filteredOptions = useMemo(function () {
    return options.filter(function (option) {
      return query === '' || option.label.toLowerCase().includes(query.toLowerCase());
    });
  }, [options, query]);
  useEffect(function () {
    if (isNull(selectedOption)) {
      setQuery('');
    }
  }, [selectedOption, setQuery]);
  var onClearClick = function onClearClick(event) {
    event.stopPropagation();
    onChange({});
    setIsFocused(false);
  };
  var onBlur = function onBlur(event) {
    var value = get(event, 'target.value', '');
    reduxOnBlur(value);
    setIsFocused(false);
  };
  return /*#__PURE__*/React.createElement(Combobox, {
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: function onFocus() {
      return setIsFocused(true);
    }
  }, function () {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(className, 'antialiased'),
      "aria-live": "polite"
    }, /*#__PURE__*/React.createElement(Combobox.Label, {
      className: classNames('block mb-1 leading-snug', 'font-extrabold font-medium-font normal-case', !hasError && 'text-13px text-blue', hasError && 'text-13px text-red', labelClassName, hideLabel && 'hidden', required && 'ui-form-field__label--required')
    }, label), /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames('relative box-border w-full bg-white cursor-default text-left', 'pl-3 py-2 border border-solid rounded-md shadow-sm focus:shadow-input-ring', !hasError && 'border-dark-border-blue ', !hasError && 'border-blue hover:border-action-blue focus:border-action-blue', hasError && 'border border-dark-border-red', hasError && 'border-red hover:border-action-red focus:border-action-red', isFocused && 'border-solid border-focus-blue', clearable && !isEmpty(selectedOption) ? 'pr-12' : 'pr-10')
    }, /*#__PURE__*/React.createElement("div", {
      className: "absolute inset-y-1"
    }, /*#__PURE__*/React.createElement(Icon, {
      "aria-hidden": true,
      className: "text-gray",
      icon: "IconSearch",
      size: 16
    })), /*#__PURE__*/React.createElement(Combobox.Input, {
      className: "h-5 w-full pl-6 leading-5 focus:outline-none",
      displayValue: value,
      onChange: function onChange(evt) {
        if (onInputChange) {
          onInputChange(evt.target.value);
        } else {
          setQuery(evt.target.value);
        }
      },
      value: value,
      placeholder: placeholder,
      id: id
    }), clearable && (!isEmpty(selectedOption) || !isEmpty(value)) && /*#__PURE__*/React.createElement("span", {
      className: "absolute opacity-50 inset-y-0 inset-x-1 right-4 flex items-center pr-5 pl-1"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "text-gray",
      icon: "IconCross",
      size: 10,
      onClick: onClearClick,
      ariaLabel: "Clear ".concat(label)
    })), /*#__PURE__*/React.createElement(Combobox.Button, {
      className: classNames('absolute inset-y-0 right-0 flex items-center pr-4 focus:outline-none', clearable && selectedOption ? 'pl-0' : 'pl-2')
    }, /*#__PURE__*/React.createElement(Icon, {
      "aria-hidden": true,
      className: "text-gray",
      icon: "IconChevronDown",
      size: 12
    }))), /*#__PURE__*/React.createElement(Combobox.Options, {
      className: classNames('absolute z-dropdown box-content pl-0 py-1 z-10 mt-1 w-full max-h-80 overflow-auto', 'bg-white shadow-lg rounded-md text-base focus:outline-none', listBoxUpOptionsClassName)
    }, filteredOptions.map(function (option) {
      return /*#__PURE__*/React.createElement(Combobox.Option, {
        className: function className(_ref) {
          var active = _ref.active;
          return classNames('relative cursor-pointer py-2 pl-3 pr-9 select-none', active && 'bg-action-blue');
        },
        key: option.value,
        value: option
      }, function (_ref2) {
        var active = _ref2.active,
          selected = _ref2.selected;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
          className: classNames('block leading-4', truncateOptions && 'truncate', active ? 'text-white' : 'text-text-blue', selected ? 'font-semibold mr-8' : 'font-normal')
        }, option.label), selected && /*#__PURE__*/React.createElement("span", {
          className: "absolute inset-y-0 right-0 flex items-center pr-4"
        }, /*#__PURE__*/React.createElement(Icon, {
          "aria-hidden": true,
          className: classNames('h-5 w-5 fill-current', active ? 'text-white' : 'text-action-blue'),
          icon: "IconCheck"
        })));
      });
    }))), hasError && error && /*#__PURE__*/React.createElement("div", {
      className: "ui-form-field__error visible mt-1.5",
      style: style.error,
      "data-test-visible": hasError,
      "data-testid": "".concat(name || id || 'unnamed', "-error")
    }, error));
  });
};
SearchableSelectField.propTypes = {
  className: PropTypes.string,
  clearable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.object, PropTypes.array, PropTypes.number]).isRequired
  })),
  label: PropTypes.node,
  labelClassName: PropTypes.string,
  hideLabel: PropTypes.bool,
  listBoxUpOptionsClassName: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  truncateOptions: PropTypes.bool,
  onInputChange: PropTypes.func,
  id: PropTypes.string,
  style: PropTypes.shape({
    container: PropTypes.object,
    error: PropTypes.object,
    hint: PropTypes.object,
    input: PropTypes.object,
    label: PropTypes.object
  })
};
SearchableSelectField.defaultProps = {
  className: '',
  clearable: false,
  options: [],
  label: '',
  labelClassName: undefined,
  listBoxUpOptionsClassName: '',
  placeholder: '',
  required: false,
  truncateOptions: true,
  hideLabel: false,
  onInputChange: null,
  id: '',
  style: {
    container: {},
    label: {},
    input: {},
    hint: {},
    error: {}
  }
};
export default SearchableSelectField;
//# sourceMappingURL=SearchableField.js.map